/** Originating records-list view for header pill navigation; mirrors viewId/recordTypeId on BackgroundJob. */
export type BackgroundJobPillNavigationContext = {
  viewId: number
  recordTypeId: number
}

export const hasBackgroundJobPillNavigationContext = (backgroundJob: {
  viewId?: number | null
  recordTypeId?: number | null
}): backgroundJob is BackgroundJobPillNavigationContext =>
  backgroundJob.viewId != null && backgroundJob.recordTypeId != null
